const bootstrap = require("bootstrap");

// 创建并显示 Bootstrap Toast
export const showMessage = (
  message: string,
  type: "success" | "danger" | "warning" | "info" = "info"
): void => {
  // 创建 toast 容器（如果不存在）
  let toastContainer = document.getElementById("toast-container");
  if (!toastContainer) {
    toastContainer = document.createElement("div");
    toastContainer.id = "toast-container";
    toastContainer.className = "position-fixed top-0 end-0 p-3";
    document.body.appendChild(toastContainer);
  }

  // 创建 toast 元素
  const toastEl = document.createElement("div");
  const toastId = `toast-${Date.now()}`;
  toastEl.id = toastId;
  toastEl.className = `toast align-items-center text-white bg-${type} border-0`;
  toastEl.setAttribute("role", "alert");
  toastEl.setAttribute("aria-live", "assertive");
  toastEl.setAttribute("aria-atomic", "true");

  // 设置 toast 内容
  toastEl.innerHTML = `
    <div class="d-flex">
      <div class="toast-body">
        ${message}
      </div>
      <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  `;

  // 添加到容器
  toastContainer.appendChild(toastEl);
  // 初始化 Bootstrap Toast
  const toast = new bootstrap.Toast(toastEl, {
    animation: true,
    autohide: true,
    delay: 3000,
  });

  // 显示 toast
  toast.show();

  // toast 隐藏后删除元素
  toastEl.addEventListener("hidden.bs.toast", () => {
    toastEl.remove();
  });
};

// 快捷方法
export const message = {
  success: (msg: string): void => showMessage(msg, "success"),
  error: (msg: string): void => showMessage(msg, "danger"),
  warning: (msg: string): void => showMessage(msg, "warning"),
  info: (msg: string): void => showMessage(msg, "info"),
};
